import { PaywallVariants } from "enums/PaywallVariants";
import PaymentFormDefault from "./default";
import PaymentFormWithMapWithContinueStep from "./locationMapV3";

export const PaymentForm = {
    [PaywallVariants.default]: PaymentFormDefault,
    [PaywallVariants.MapV3]: PaymentFormWithMapWithContinueStep,
};
